import { PayloadProps, PutPayloadProps } from "src/models/service.models";

import API_URL from "./apiConfig/api.config";
import apiCall from "./apiConfig/apiCall.config";

export async function addSoftwareCategory(data: PayloadProps) {
  return await apiCall.post(
    API_URL.CATEGORY_MANAGEMENT.MANAGE_SOFTWARE.ADD_SOFTWARE,
    data
  );
}
export async function getSoftwareCategory() {
  return await apiCall.get(
    API_URL.CATEGORY_MANAGEMENT.MANAGE_SOFTWARE.GET_SOFTWARE_LIST
  );
}

export async function editSoftwareCategory(
  params: string,
  data: PutPayloadProps
) {
  return await apiCall.put(
    API_URL.CATEGORY_MANAGEMENT.MANAGE_SOFTWARE.PUT_SOFTWARE + params,
    data
  );
}
export async function deleteSoftwareCategory(params: string) {
  return await apiCall.remove(
    API_URL.CATEGORY_MANAGEMENT.MANAGE_SOFTWARE.PUT_SOFTWARE + params
  );
}
